import React from 'react';
import PropTypes from 'prop-types';

import Button from '@components/smartAdminUI/Button';
import Alert from 'react-bootstrap/Alert';

const RowLockOwnerMessage = ({
  onRemoveLock = () => null,
}) => (
  <div className="row">
    <div className="col-lg-12">
      <Alert variant="warning">
        <h3>
          <i className="far fa-lock mr-2" />
          This entity is currently locked.
        </h3>
        <p>You currently hold a lock for this entity. Do you wish to release the lock?</p>
        <Button name="btnReleaseLock" variant="primary" onClick={onRemoveLock}>
          <i className="fas fa-lock-open mr-2" aria-hidden="true" />
          Release lock
        </Button>
      </Alert>
    </div>
  </div>
);

RowLockOwnerMessage.propTypes = {
  onRemoveLock: PropTypes.func,
};

export default RowLockOwnerMessage;
